import { render } from "./AdminWithdrawRequestEdit.vue?vue&type=template&id=3a1df4c2&scoped=true&ts=true"
import script from "./AdminWithdrawRequestEdit.vue?vue&type=script&lang=ts"
export * from "./AdminWithdrawRequestEdit.vue?vue&type=script&lang=ts"

import "./AdminWithdrawRequestEdit.vue?vue&type=style&index=0&id=3a1df4c2&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1df4c2"]])

export default __exports__